import styles from "./Spinner.module.css";

const Spinner = () => {
  return (
    <div className={styles.container}>
      <div className={styles.spinner} role="alert" aria-live="assertive">
        <p className={styles.text}>Laster inn data...</p>
      </div>
    </div>
  );
};

export default Spinner;
